import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useStateContext } from '../../context/ContextProvider';
import { DLabel, Select, DSpinButton, TextArea } from '../utils/Form';
import { getAllCategorys } from '../../redux/actions/category';
import { toast } from 'react-toastify';
import { Loader } from '../utils';
import { BaseUrl } from '../../server';
import ImageUploadWithResize from '../../utils/ImageUploadWithResize'; // ✅ استيراد المكون

function CreateCategory() {
  const { t } = useTranslation();
  const { currentColor } = useStateContext();
  const { isLoading, AllCategorys } = useSelector((state) => state.Categorys);
  const dispatch = useDispatch();
  const [isSpinner, setIsSpinner] = useState(false);
  const [titleAr, setTitleAr] = useState("");
  const [titleEn, setTitleEn] = useState("");
  const [textEn, setTextEn] = useState("");
  const [textAr, setTextAr] = useState("");
  const [image, setImage] = useState(null);
  const [imageShow, setImageShow] = useState(null);

  useEffect(() => {
    dispatch(getAllCategorys());
  }, [dispatch]);

  const Createcategory = async (newForm) => {
    try {
      const config = { 
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true 
      };
      const { data } = await axios.post(`${BaseUrl}/category/create`, newForm, config);
      
      if (data.success) {
        // عرض رسالة نجاح
        toast.success(
          <span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">
            {t("Meals Category created successfully!")}
          </span>
        );

        // إعادة تعيين الحالات
        setIsSpinner(false);
        setTitleAr("");
        setTitleEn("");
        setTextAr("");
        setTextEn("");
        setImage(null);
        setImageShow(null);
      }
    } catch (error) {
      // عرض رسالة خطأ
      const errorMessage = error.response?.data?.message || error.message;
      toast.error(
        <span className="font-kufi text-sm">
          {typeof errorMessage === 'string' ? errorMessage : t("An error occurred")}
        </span>
      );
      setIsSpinner(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // التحقق من البيانات المطلوبة
    if (!image) {
      toast.error(t("Please select an image"));
      return;
    }
    
    setIsSpinner(true);
    const newForm = new FormData();
    newForm.append("file", image);
    newForm.append("titleAr", titleAr);
    newForm.append("titleEn", titleEn);
    newForm.append("textAr", textAr);
    newForm.append("textEn", textEn);

    Createcategory(newForm);
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="w-[90%] bg-back-primery lg:w-[50%] m-2 md:m-10 mt-24 p-2 md:p-10 rounded-3xl">
          <h3 className="text-xl font-semibold text-color-1 font-kufi color text-center">
            {t("Create Category")}
          </h3>
          <form onSubmit={handleSubmit}>
            <br />
            <div>
              <DLabel
                labelText="Title (Ar)"
                value={titleAr}
                onChange={(e) => setTitleAr(e.target.value)}
                required={true}
                type="text"
                name="titleAr"
              />
              <DLabel
                labelText="Title (En)"
                value={titleEn}
                onChange={(e) => setTitleEn(e.target.value)}
                required={true}
                type="text"
                name="titleEn"
              />

              <TextArea 
                labelText="Description (ar)" 
                value={textAr} 
                onChange={(e) => setTextAr(e.target.value)} 
                required={true} 
              />
              
              <TextArea 
                labelText="Description (en)" 
                value={textEn} 
                onChange={(e) => setTextEn(e.target.value)} 
                required={true} 
              />

              {/* ✅ استخدام كمبوننت ضغط الصور بدلاً من الكود القديم */}
              <ImageUploadWithResize
                imageShow={imageShow}
                setImageShow={setImageShow}
                setImage={setImage}
                currentColor={currentColor}
                label="Upload Image"
                required={true}
                maxWidth={800}   // يمكن تصغير حجم صورة الفئة أكثر
                maxHeight={800}
                quality={75}     // جودة أقل قليلاً للفئات
              />
              
              <br />
            </div>
            <DSpinButton isLoading={isSpinner}>
              {isSpinner ? t("Creating...") : t("Create")}
            </DSpinButton>
          </form>
        </div>
      )}
    </>
  );
}

export default CreateCategory;